module.exports = __webpack_public_path__ + "img/panchito_top_right_fallback-min.6bd39d00.png";